import React from 'react';

import { useLabels } from '../../i18n/useLabels';
import type { SectionsRailViewModel } from '../../viewmodels/createSectionsRailViewModel';
import { SectionsRailEntry } from './SectionsRailEntry';

import styles from './SectionsRail.scss';

type Props = {
  viewModel: SectionsRailViewModel;
};

export function SectionsRail({ viewModel }: Props) {
  const labels = useLabels();

  return (
    <nav className={styles.rail} aria-label={labels.sectionsRailLabel}>
      <div className={styles.title}>{labels.sectionsRailTitle}</div>
      <ul className={styles.list}>
        {viewModel.entries.map(entry => (
          <SectionsRailEntry key={entry.id} viewModel={entry} />
        ))}
      </ul>
    </nav>
  );
}
